import { useState } from "react"

import "./styles.css"

import { modalHandle } from "../../core"

import Layout from "../../components/Layout"
import Dropdown from "../../components/Dropdown"
import Loader from "../../components/Loader"

import { IoIosSearch } from "react-icons/io"
import { FiMenu } from "react-icons/fi"
import { BiErrorCircle } from "react-icons/bi"
import { useCsvData } from "../../utils/mocks/csv/useCsvData"
import { normalizeText } from "../../utils/normalizeText"

const Manual = ({ setModalContent }) => {
  const { data: manualContent, loading } = useCsvData(undefined)
  const [filterAbility, setFilterAbility] = useState("Todos")
  const [filterLevel, setFilterLevel] = useState("Todos")
  const [filterCategory, setfilterCategory] = useState("")
  const [search, setSearch] = useState("")
  const abilities = ["Todos", "Comunicativa", "Social", "Motora"]

  const etiquetas = [
    "Motricidade Global",
    "Percepção Auditiva",
    "Sensorio Social",
    "Esquema Corporal",
    "Linguagem",
    "Cognição",
  ]

  const levels = ["Todos", "Nível 1", "Nível 2", "Nível 3"]

  const getNumber = (item) => {
    if (item !== "Todos") {
      let regex = /\d+/g
      let matches = item.match(regex)
      return matches[0]
    }

    return item
  }

  const handleSelectCategoryFilter = (etiqueta) => {
    setfilterCategory((current) => (current === etiqueta ? "" : etiqueta))
  }

  //MAPEMANETO DOS CAMPOS

  const renderContentDetail = (data) => {
    return (
      <>
        {data.map((item, index) => (
          <div className="activity-card" key={index}>
            <div className="item">
              <div className="item-title">
                {item.name}
                <br></br>
              </div>
            </div>
            <div className="texto-atividades">{item.description}</div>

            <div className="coluna-detalhes">
              <div className="item-atributo">
                <strong>Habilidade {item.ability}:</strong> Nível{" "}
                {item.ability_score}
              </div>

              {item.subscore ? (
                <div className="item-atributo">
                  <strong>Subnível:</strong> {item.subscore}
                </div>
              ) : null}

              {item.category ? (
                <div className="item-atributo">
                  <strong>Categoria:</strong>
                  <div className="etiqueta-full-manual">{item.category}</div>
                </div>
              ) : null}

              <div className="item-atributo">
                <div
                  className="item-detail"
                  onClick={() => {
                    setModalContent(item)
                    modalHandle("open")
                  }}
                >
                  <FiMenu style={{ fontSize: "22px" }} />
                  <div className="item-detail-text">Detalhes</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    )
  }

  const loadData = () => {
    if (!loading && manualContent) {
      return renderContentDetail(
        manualContent.filter((it) => {
          const matchSearch =
            search === "" ||
            search.length < 3 ||
            normalizeText(search)
              .split(" ")
              .every((s) => normalizeText(it.name).includes(s))

          const matchCategory =
            filterCategory === "" ||
            it.category.toLowerCase() === filterCategory.toLowerCase()

          const matchAbility =
            filterAbility === "Todos" ||
            it.ability.toLowerCase() === filterAbility.toLowerCase()

          const matchLevel =
            filterLevel === "Todos" ||
              it.ability_score === Number(filterLevel)

          return matchSearch && matchCategory && matchAbility && matchLevel
        }),
      )
    } else if (loading) {
      return <Loader size={40} />
    } else {
      return (
        <div className="item-error">
          <BiErrorCircle /> Houve um erro ao processar sua solicitação.
        </div>
      )
    }
  }

  return (
    <Layout
      title="Manual de Atividades Lúdicas"
      titleColor="#b25fa3"
      description='Aqui você encontra todas as atividades lúdicas do sistema. 
    Caso deseje verificar a ficha de uma atividade, clique em "Detalhes".'
      children={
        <>
          <div className="filter-items-container">
            <div className="choose-wrapper">
              <div className="choose-content">
                <Dropdown
                  data={abilities}
                  changeHandle={(item) => {
                    setFilterAbility(item.label)
                    console.log(item)
                  }}
                />
                <div className="dropdown-description">
                  Filtro por habilidade
                </div>
              </div>
              <div className="choose-content">
                <Dropdown
                  data={levels}
                  changeHandle={(item) => {
                    setFilterLevel(getNumber(item.label))
                  }}
                />
                <div className="dropdown-description">
                  Filtro por nível de habilidade
                </div>
              </div>
            </div>

            <div className="search-container-linha">
              <input
                placeholder="Busca"
                type="text"
                className="search-field"
                onChange={(event) => setSearch(event.target.value)}
              />
              <IoIosSearch color="rgba(0, 0, 0, 0.8)" />
            </div>
          </div>
          <div className="etiquetas-container">
            Categoria:
            <div className="etiquetas">
              {etiquetas.map((etiqueta, idx) => (
                <button
                  key={idx}
                  className={
                    filterCategory === etiqueta
                      ? "etiqueta-vazada etiqueta-vazada--active"
                      : "etiqueta-vazada"
                  }
                  onClick={() => handleSelectCategoryFilter(etiqueta)}
                >
                  {etiqueta}
                </button>
              ))}
            </div>
          </div>

          <div className="items-container">{loadData()}</div>
        </>
      }
    />
  )
}

export default Manual
